{
  "SEARCH": {
    "TABS": {
      "ALL": "Visi",
      "CONTACTS": "Kontaktai",
      "CONVERSATIONS": "Pokalbiai",
      "MESSAGES": "Pranešimai"
    },
    "SECTION": {
      "CONTACTS": "Kontaktai",
      "CONVERSATIONS": "Pokalbiai",
      "MESSAGES": "Pranešimai"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Ieškoma",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "Nerasta {item} pagal užklausą '{query}'",
    "EMPTY_STATE_FULL": "Nerasta rezultatų pagal užklausą '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ sutelkti dėmesį",
    "INPUT_PLACEHOLDER": "Įveskite 3 ar daugiau smibolius paieškai",
    "RECENT_MESSAGES": "Mano neseniai išsiųsti pranešimai",
    "EMPTY_STATE_DEFAULT": "Norėdami gauti geresnių paieškos rezultatų, ieškokite pagal pokalbio ID, el. pašto adresą, telefono numerį, žinutes.",
    "BOT_LABEL": "Botas",
    "READ_MORE": "Skaityti daugiau",
    "WROTE": "parašei:",
    "FROM": "nuo",
    "EMAIL": "el. paštas",
    "EMAIL_SUBJECT": "tema"
  }
}
